import React from 'react';

import type { TComponentsMap, TPages, TRouteComponent } from '../../types';
import ComponentsMapProvider from '../ComponentsMapProvider';
import RoutesFactory from '../RoutesFactory';

type TPageProps = {
  componentsMap: TComponentsMap;
  pages?: TPages;
};

const PageWrapper: Component<TPageProps & TRouteComponent> = ({
  componentsMap,
  pages = {},
  unAuthorizedRoute,
  homePageRoute,
  page404Route,
  pageFormFactor,
  isAuthFetched,
  isAuthenticated,
  LayoutComponent,
  LoaderComponent,
  children
}) => {

  return (
    <ComponentsMapProvider componentsMap={componentsMap}>
      <RoutesFactory
        pages={pages}
        unAuthorizedRoute={unAuthorizedRoute}
        homePageRoute={homePageRoute}
        page404Route={page404Route}
        pageFormFactor={pageFormFactor}
        isAuthFetched={isAuthFetched}
        isAuthenticated={isAuthenticated}
        LayoutComponent={LayoutComponent}
        LoaderComponent={LoaderComponent}
      />
      {children}
    </ComponentsMapProvider>
  );
};

export default PageWrapper;
